import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
// import { Turbo } from "@hotwired/turbo-rails"

/* Objecten */
export default class extends Controller {
  static targets = [ "item_type" ]

  connect() {
    // console.log("Hello, ItemsController!", this.element);
  }

  // Bij wijzigen objecttype, haal de omschrijvingen van het objecttype op
  update_item_type() {
    // The string INPUT type for the autocomplete name of item_type:
    const item_type_input_elm= this.item_typeTarget;

    // The hidden item_type ID element
    const item_type_id_elm= item_type_input_elm.parentElement.querySelector(item_type_input_elm.dataset.acTargetId);

    // The material additive input select element
    const materialAdditiveItem= document.querySelector('#item_material_additive_id')

    // The useType additive input select element
    const useTypeAdditiveItem= document.querySelector('#item_use_type_additive_id')

    // The finish autocomplete input field
    const finishItem= document.querySelector('#finish_acname')

    // The sole autocomplete input field
    const soleItem= document.querySelector('#sole_acname')

    // The gripe autocomplete input field
    const gripeItem= document.querySelector('#gripe_acname')

    // On a valid item_type_id, get the full JSON representation of the item_type
    if (item_type_id_elm.value) {
      const item_type_url= item_type_input_elm.dataset.acUrl + '/' + item_type_id_elm.value;
      
      const getRequest= get(item_type_url, {
        responseKind: "json",    // andere opties: json, turbo_stream
      })
        .then(response => response.json)
        .then(json => {
          console.log(json);
          document.querySelector('#item_type_name').textContent= (json.description && json.description.length==0) ? '&emsp;' : json.description;
          document.querySelector('#material_name').textContent= json.material.name;
          document.querySelector('#use_type_name').textContent= json.use_type.name;

          this.update_material_additives(materialAdditiveItem, json.material_id);
          this.update_use_type_additives(useTypeAdditiveItem, json.use_type_id, json.material_id);
          this.update_finish(finishItem, json.material.group);
          this.update_sole(soleItem, json.material.group);
          this.update_gripe(gripeItem, json.material.group);
        })

    } else {
      document.querySelector('#item_type_name').textContent= null;
      document.querySelector('#material_name').textContent= null
      document.querySelector('#use_type_name').textContent= null

      // Clear input select options
      materialAdditiveItem.innerHTML= ''
      useTypeAdditiveItem.innerHTML= ''
    }
  }

  update_finish(finishItem, group) {
    if (finishItem) {
      // Manipulate the autocomplete URL for finishes with the material group (application)
      const acUrl= new URL(finishItem.dataset.acUrl);
      if (acUrl.searchParams.has('application')) {
        acUrl.searchParams.set('application', group);  
      } else {
        acUrl.searchParams.append('application', group);
      }
      finishItem.dataset.acUrl= acUrl.toString();
    }
  }

  update_sole(soleItem, group) {
    if (soleItem) {
      // Manipulate the autocomplete URL for soles with the material group (application)
      const acUrl= new URL(soleItem.dataset.acUrl);
      if (acUrl.searchParams.has('application')) {
        acUrl.searchParams.set('application', group);  
      } else {
        acUrl.searchParams.append('application', group);
      }
      soleItem.dataset.acUrl= acUrl.toString();
    }
  }

  update_gripe(gripeItem, group) {
    if (gripeItem) {
      // Manipulate the autocomplete URL for gripes with the material group (application)
      const acUrl= new URL(gripeItem.dataset.acUrl);
      if (acUrl.searchParams.has('application')) {
        acUrl.searchParams.set('application', group);  
      } else {
        acUrl.searchParams.append('application', group);
      }
      gripeItem.dataset.acUrl= acUrl.toString();
    }
  }

  update_material_additives(materialAdditiveItem, material_id) {
    if (materialAdditiveItem) {
      // Fetch <options><options> HTML
      const params = new URLSearchParams()
      if (materialAdditiveItem.value!='') {
        params.append("current_id", materialAdditiveItem.value)
      }

      fetch(`/materials/${material_id}/additives/list_options?${params.toString()}`, 
          {headers: {'Accept': 'text/html'}})
        .then(response => response.ok ? response.text() : null)
        .then(html => {
          if (!html || html.trim() === "") return
          materialAdditiveItem.innerHTML= html;
      })
    }
  }

  update_use_type_additives(useTypeAdditiveItem, use_type_id, material_id) {
    if (useTypeAdditiveItem) {
      // Fetch <options><options> HTML
      const params = new URLSearchParams()
      params.append('material_id', material_id)
      if (useTypeAdditiveItem.value!='') {
        params.append("current_id", useTypeAdditiveItem.value)
      }

      fetch(`/use_types/${use_type_id}/additives/list_options?${params.toString()}`, 
          {headers: {'Accept': 'text/html'}})
        .then(response => response.ok ? response.text() : null)
        .then(html => {
          if (!html || html.trim() === "") return
          useTypeAdditiveItem.innerHTML= html;
      })
    }
  }


  // update_material_additives_via_turbostream(material_id) {
  //   const materialAdditiveItem= document.querySelector('#item_material_additive_id')
  //   if (materialAdditiveItem) {
  //     // Fetch TurboStream request and execute it via Turbo.renderStreamMessage
  //     fetch(`/materials/${material_id}/additives/list_options`, { headers: { 'Accept': 'text/vnd.turbo-stream.html' } })
  //       .then(response => response.ok ? response.text() : null)
  //       .then(html => {
  //         if (!html || html.trim() === "") return
  //         Turbo.renderStreamMessage(html)
  //     })
  //   }
  // }

}
